<template>
  <Popup :isShow="isShow">
    <div v-long-touch="onLongTouch" class="popup-tip-success">
      <img class="icon-ok" src="./assets/icon-ok.svg" />
      <img
        v-if="closable"
        class="icon-close"
        src="./assets/icon-close.svg"
        @click="$emit('close')"
      />
      <div class="status">{{ textConfig.status || '已购买' }}</div>
      <div v-if="textConfig.guide" class="guide">
        <div v-for="(item, index) in textConfig.guide" :key="index">
          {{ item }}
        </div>
        <!-- <div>关注公众号，分配学习助理</div> -->
      </div>
      <div v-if="textConfig.tip" class="tip">{{ textConfig.tip }}</div>
      <div v-if="textConfig.warn" class="warn">{{ textConfig.warn }}</div>
      <div class="qrcode" :class="'qrcode-' + qrcodePos">
        <img
          v-if="qrcode || textConfig.qrcode"
          :src="qrcode || textConfig.qrcode"
          alt
        />
        <div v-else class="icon-reload" @click="$emit('reloadQrcode')" />
      </div>
      <div v-if="textConfig.footer" class="footer">
        <div v-for="(item, index) in textConfig.footer" :key="index">
          {{ item }}
        </div>
      </div>
      <AssistantFeedback
        v-if="textConfig.assistant_id"
        :id="textConfig.assistant_id"
        :defaultIsFeedback="textConfig.is_feedback"
        :feedbackLink="textConfig.feedback_link"
        class="feedback"
      ></AssistantFeedback>
    </div>
  </Popup>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Popup from '@/components/Popup';
import { IConfig } from './index';
import AssistantFeedback from '@/modules/common/AssistantFeedback';
import directive from '@lib/event/long-touch';

Vue.directive('long-touch', directive);

@Component({
  components: {
    Popup,
    AssistantFeedback,
  },
})
export default class PopupTipSuccess extends Vue {
  @Prop({ type: Boolean, default: false }) isShow!: boolean;
  @Prop({ type: Boolean, default: true }) closable!: boolean;
  @Prop(String) qrcode!: string;
  @Prop({
    type: Object,
    default: () => {
      return {
        status: '已购买',
      };
    },
  })
  textConfig!: IConfig;
  @Prop({ type: Boolean, default: false }) isShowFeedback!: boolean;
  get qrcodePos() {
    if (
      !this.textConfig.tip &&
      !this.textConfig.warn &&
      !this.textConfig.footer
    ) {
      return '3';
    }
    return '';
  }

  onLongTouch() {
    this.$emit('longTouch');
  }
}
</script>

<style lang="scss" scoped>
.popup-tip-success {
  // position: fixed;
  // bottom: 0;
  // left: 0;
  position: relative;
  // box-shadow: 0px 0px 30px rgb(205, 205, 205);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 754px;
  padding-top: 40px;
  padding-bottom: 42px;
  background-color: #ffffff;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  .icon-ok {
    // margin-top: 40px;
    width: 100px;
  }
  .icon-close {
    position: absolute;
    top: 40px;
    right: 40px;
    width: 32px;
    height: 32px;
  }
  .status {
    margin-top: 14px;
    color: #35e4a6;
    font-weight: 600;
    font-size: 30px;
  }
  .guide {
    margin-top: 29px;
    color: #2f2f2f;
    font-weight: 600;
    font-size: 40px;
    text-align: center;
  }
  .tip {
    margin-top: 19px;
    color: rgba($color: #2f2f2f, $alpha: 0.68);
    font-size: 28px;
  }
  .warn {
    margin-top: 10px;
    color: #e52f6e;
    font-size: 28px;
  }
  .qrcode {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 260px;
    height: 260px;
    margin-top: 25px;
    border: 11px solid #f1f1f6;
    border-radius: 6px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }
  }
  .qrcode-3 {
    margin-top: 63px;
  }
  .footer {
    margin-top: 14px;
    color: rgba($color: #1f2d3d, $alpha: 0.5);
    font-weight: 500;
    font-size: 22px;
    text-align: center;
  }
  .feedback {
    margin-top: 40px;
  }
}
.icon-reload {
  width: 66px;
  height: 66px;
  background-image: url(https://res.pandateacher.com/8LM6XAQY1630920992953.png);
  background-size: cover;
}
</style>
